import React from 'react';

const MinusIcon = () => (
  <svg width="40" height="23" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M.406 21.793a1.394 1.394 0 0 0 1.976 0L20.006 4.17 37.63 21.793a1.396 1.396 0 0 0 1.973-1.975L20.992 1.205a1.396 1.396 0 0 0-1.973 0L.406 19.818a1.394 1.394 0 0 0-.406.987c0 .385.154.735.406.988Z"
      fill="#000"
    />
  </svg>
);

export default MinusIcon;
